import { Timestamp } from 'firebase/firestore'
import { Dispatch, SetStateAction } from 'react'

export interface Cause {
  id: string
  createdAt?: Timestamp
  lastUpdated?: Timestamp
  lowercaseName?: string
  name?: string
  users?: number
  organizations?: number
}

export interface CauseWithValue extends Cause {
  value?: string
  rayze?: string
}

// Context Props
export interface CauseContextProps {
  fetchCauses: () => Promise<void>
  fetchCause: (id: string) => Promise<void>
  deleteCause: (id: string) => Promise<void>
  createCause: (causeName: string) => Promise<void>
  causes: Cause[] | []
  setCauses: Dispatch<SetStateAction<Cause[] | []>>
}

export const CauseContextDefaultValues: CauseContextProps = {
  fetchCauses: async () => {},
  fetchCause: async (id: string) => {
    void id
  },
  deleteCause: async (id: string) => {
    void id
  },
  createCause: async (causeName: string) => {
    void causeName
  },
  causes: [],
  setCauses: () => {},
}

export interface CausesContextProps {
  allCauses: Cause[] | []
  setAllCauses: (causes: Cause[]) => void
  ourCauses: Cause[] | []
  setOurCauses: (causes: Cause[]) => void
}

export const CausesContextDefaultValues: CausesContextProps = {
  allCauses: [],
  setAllCauses: () => {},
  ourCauses: [],
  setOurCauses: () => {},
}
